export default {
  title: '價格資料',
  schema: {
    type: 'Object',
    contents: {
      productRef: {
        name: '商品',
        type: 'ObjectId',
        reference: 'products',
        required: true,
        refKeys: ['key'],
      },
      pricebookRef: {
        name: '價格表',
        type: 'ObjectId',
        reference: 'pricebooks',
        required: true,
        refKeys: ['key'],
      },
      price: {
        name: '價格',
        type: 'Number',
        // required: true,
      },
    },
  },
  index: {
    primary: {
      key: {
        productRef: 1,
        pricebookRef: 1,
      },
      unique: true,
    },
  },
  list: {
    ui: {
      fields: [
        { path: 'productRef', width: 120 },
        { path: 'pricebookRef', width: 120 },
        { path: 'price' },
      ],
    },
  },
  ui: {
    editor: {
      config: { nameWidth: 110 },
      groups: [
        {
          name: '',
          rows: [
            [{ key: 'productRef' }, { key: 'pricebookRef' }],
            [{ key: 'price' }],
          ],
        },
      ],
    },
  },
}
